import { render } from "./StaffDashboard.vue?vue&type=template&id=7289f0de&scoped=true"
import script from "./StaffDashboard.vue?vue&type=script&lang=js"
export * from "./StaffDashboard.vue?vue&type=script&lang=js"

import "./StaffDashboard.vue?vue&type=style&index=0&id=7289f0de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7289f0de"]])

export default __exports__